import { render, staticRenderFns } from "./member-details.vue?vue&type=template&id=641f3254&scoped=true&"
import script from "./member-details.vue?vue&type=script&lang=js&"
export * from "./member-details.vue?vue&type=script&lang=js&"
import style0 from "./member-details.vue?vue&type=style&index=0&id=641f3254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f3254",
  null
  
)

export default component.exports